import Item from './Item.js';

export default class HealingItem extends Item {
    constructor({
        id,
        name,
        description,
        healAmount = 0,
        healStatus = [],
        price,
        overworldOptions = ['Use', 'Give', 'Cancel'],
        battleOptions = ['Use', 'Cancel'],
    }) {
        super({ id, name, description, price, overworldOptions, battleOptions });
        this.healAmount = healAmount;
        this.healStatus = healStatus;
    }
}
